export default {
  redshift: {
    dbTypes: [
      'SMALLINT',
      'INT2',
      'INTEGER',
      'INT',
      'INT4',
      'BIGINT',
      'INT8',
      'DECIMAL(18,4)',
      'NUMERIC(18,4)',
      'REAL',
      'FLOAT4',
      'DOUBLE PRECISION',
      'FLOAT8',
      'BOOLEAN',
      'BOOL',
      'CHAR',
      'CHARACTER',
      'VARCHAR(65535)',
      'CHARACTER VARYING',
      'DATE',
      'TIMESTAMP',
      'TIMESTAMPTZ',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'VARCHAR',
      array: 'VARCHAR(65535)',
      integer: 'INT',
      object: 'VARCHAR(65535)',
      unknown: 'VARCHAR(65535)',
    },
  },
  mysql: {
    dbTypes: [
      'TINYINT',
      'SMALLINT',
      'MEDIUMINT',
      'INT',
      'BIGINT',
      'DECIMAL',
      'FLOAT',
      'DOUBLE',
      'BIT',
      'BOOLEAN',
      'BOOL',
      'CHAR',
      'VARCHAR(1024)',
      'VARCHAR(4096)',
      'BINARY',
      'VARBINARY(65535)',
      'TINYBLOB',
      'BLOB',
      'MEDIUMBLOB',
      'LONGBLOB',
      'TINYTEXT',
      'TEXT',
      'MEDIUMTEXT',
      'LONGTEXT',
      'ENUM',
      'SET',
      'DATE',
      'DATETIME',
      'TIMESTAMP',
      'YEAR',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'BOOLEAN',
      string: 'VARCHAR(1024)',
      array: 'TEXT',
      integer: 'INT',
      object: 'TEXT',
      unknown: 'VARCHAR(1024)',
    },
  },
  cloudsql_mysql: {
    dbTypes: [
      'TINYINT',
      'SMALLINT',
      'MEDIUMINT',
      'INT',
      'BIGINT',
      'DECIMAL',
      'FLOAT',
      'DOUBLE',
      'BIT',
      'BOOLEAN',
      'BOOL',
      'CHAR',
      'VARCHAR(4096)',
      'BINARY',
      'VARBINARY(65535)',
      'TINYBLOB',
      'BLOB',
      'MEDIUMBLOB',
      'LONGBLOB',
      'TINYTEXT',
      'TEXT',
      'MEDIUMTEXT',
      'LONGTEXT',
      'ENUM',
      'SET',
      'DATE',
      'DATETIME',
      'TIMESTAMP',
      'YEAR',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'TINYINT(1)',
      string: 'VARCHAR(4096)',
      array: 'VARCHAR(4096)',
      integer: 'INT',
      object: 'VARCHAR(4096)',
      unknown: 'VARCHAR(65535)',
    },
  },
  snowflake: {
    dbTypes: [
      'NUMBER',
      'DECIMAL',
      'NUMERIC',
      'INT',
      'INTEGER',
      'BIGINT',
      'SMALLINT',
      'FLOAT',
      'FLOAT4',
      'FLOAT8',
      'DOUBLE',
      'DOUBLE PRECISION',
      'REAL',
      'VARCHAR',
      'CHAR',
      'CHARACTER',
      'STRING',
      'TEXT',
      'BINARY',
      'VARBINARY',
      'BOOLEAN',
      'DATE',
      'DATETIME',
      'TIME',
      'TIMESTAMP',
      'TIMESTAMP_LTZ',
      'TIMESTAMP_NTZ',
      'TIMESTAMP_TZ',
      'VARIANT',
      'OBJECT',
      'ARRAY',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'ARRAY',
      integer: 'INT',
      object: 'VARIANT',
      unknown: 'TEXT',
    },
  },
  snowflake_dcr: {
    dbTypes: [
      'NUMBER',
      'DECIMAL',
      'NUMERIC',
      'INT',
      'INTEGER',
      'BIGINT',
      'SMALLINT',
      'FLOAT',
      'FLOAT4',
      'FLOAT8',
      'DOUBLE',
      'DOUBLE PRECISION',
      'REAL',
      'VARCHAR',
      'CHAR',
      'CHARACTER',
      'STRING',
      'TEXT',
      'BINARY',
      'VARBINARY',
      'BOOLEAN',
      'DATE',
      'DATETIME',
      'TIME',
      'TIMESTAMP',
      'TIMESTAMP_LTZ',
      'TIMESTAMP_NTZ',
      'TIMESTAMP_TZ',
      'VARIANT',
      'OBJECT',
      'ARRAY',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'ARRAY',
      integer: 'INT',
      object: 'VARIANT',
      unknown: 'TEXT',
    },
  },
  postgres: {
    dbTypes: [
      'BIGINT',
      'INT8',
      'BIGSERIAL',
      'SERIAL8',
      'BIT',
      'BIT_VARYING',
      'VARBIT',
      'BOOLEAN',
      'BOOL',
      'BOX',
      'BYTEA',
      'CHAR',
      'VARCHAR',
      'CHARACTER VARYING',
      'CIDR',
      'CIRCLE',
      'DATE',
      'DOUBLE PRECISION',
      'INET',
      'INTEGER',
      'INT',
      'INT4',
      'INTERVAL',
      'JSON',
      'JSONB',
      'LINE',
      'LSEG',
      'MACADDR',
      'MONEY',
      'NUMERIC',
      'DECIMAL',
      'PATH',
      'PG_LSN',
      'POINT',
      'POLYGON',
      'REAL',
      'FLOAT4',
      'SMALLINT',
      'INT2',
      'SMALLSERIAL',
      'SERIAL2',
      'SERIAL',
      'SERIAL4',
      'TEXT',
      'TIME',
      'TIMETZ',
      'TIMESTAMP',
      'TIMESTAMPTZ',
      'TSQUERY',
      'TSVECTOR',
      'TXID_SNAPSHOT',
      'UUID',
      'XML',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'JSONB',
      integer: 'INT',
      object: 'JSONB',
      unknown: 'TEXT',
    },
  },
  gcp_alloydb: {
    dbTypes: [
      'BIGINT',
      'INT8',
      'BIGSERIAL',
      'SERIAL8',
      'BIT',
      'BIT_VARYING',
      'VARBIT',
      'BOOLEAN',
      'BOOL',
      'BOX',
      'BYTEA',
      'CHAR',
      'VARCHAR',
      'CHARACTER VARYING',
      'CIDR',
      'CIRCLE',
      'DATE',
      'DOUBLE PRECISION',
      'INET',
      'INTEGER',
      'INT',
      'INT4',
      'INTERVAL',
      'JSON',
      'JSONB',
      'LINE',
      'LSEG',
      'MACADDR',
      'MONEY',
      'NUMERIC',
      'DECIMAL',
      'PATH',
      'PG_LSN',
      'POINT',
      'POLYGON',
      'REAL',
      'FLOAT4',
      'SMALLINT',
      'INT2',
      'SMALLSERIAL',
      'SERIAL2',
      'SERIAL',
      'SERIAL4',
      'TEXT',
      'TIME',
      'TIMETZ',
      'TIMESTAMP',
      'TIMESTAMPTZ',
      'TSQUERY',
      'TSVECTOR',
      'TXID_SNAPSHOT',
      'UUID',
      'XML',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'JSONB',
      integer: 'INT',
      object: 'JSONB',
      unknown: 'TEXT',
    },
  },
  cloudsql_postgres: {
    dbTypes: [
      'BIGINT',
      'INT8',
      'BIGSERIAL',
      'SERIAL8',
      'BIT',
      'BIT_VARYING',
      'VARBIT',
      'BOOLEAN',
      'BOOL',
      'BOX',
      'BYTEA',
      'CHAR',
      'VARCHAR',
      'CHARACTER VARYING',
      'CIDR',
      'CIRCLE',
      'DATE',
      'DOUBLE PRECISION',
      'INET',
      'INTEGER',
      'INT',
      'INT4',
      'INTERVAL',
      'JSON',
      'JSONB',
      'LINE',
      'LSEG',
      'MACADDR',
      'MONEY',
      'NUMERIC',
      'DECIMAL',
      'PATH',
      'PG_LSN',
      'POINT',
      'POLYGON',
      'REAL',
      'FLOAT4',
      'SMALLINT',
      'INT2',
      'SMALLSERIAL',
      'SERIAL2',
      'SERIAL',
      'SERIAL4',
      'TEXT',
      'TIME',
      'TIMETZ',
      'TIMESTAMP',
      'TIMESTAMPTZ',
      'TSQUERY',
      'TSVECTOR',
      'TXID_SNAPSHOT',
      'UUID',
      'XML',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'JSONB',
      integer: 'INT',
      object: 'JSONB',
      unknown: 'TEXT',
    },
  },
  supabase: {
    dbTypes: [
      'BIGINT',
      'INT8',
      'BIGSERIAL',
      'SERIAL8',
      'BIT',
      'BIT_VARYING',
      'VARBIT',
      'BOOLEAN',
      'BOOL',
      'BOX',
      'BYTEA',
      'CHAR',
      'VARCHAR',
      'CHARACTER VARYING',
      'CIDR',
      'CIRCLE',
      'DATE',
      'DOUBLE PRECISION',
      'INET',
      'INTEGER',
      'INT',
      'INT4',
      'INTERVAL',
      'JSON',
      'JSONB',
      'LINE',
      'LSEG',
      'MACADDR',
      'MONEY',
      'NUMERIC',
      'DECIMAL',
      'PATH',
      'PG_LSN',
      'POINT',
      'POLYGON',
      'REAL',
      'FLOAT4',
      'SMALLINT',
      'INT2',
      'SMALLSERIAL',
      'SERIAL2',
      'SERIAL',
      'SERIAL4',
      'TEXT',
      'TIME',
      'TIMETZ',
      'TIMESTAMP',
      'TIMESTAMPTZ',
      'TSQUERY',
      'TSVECTOR',
      'TXID_SNAPSHOT',
      'UUID',
      'XML',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'JSONB',
      integer: 'INT',
      object: 'JSONB',
      unknown: 'TEXT',
    },
  },
  oracle: {
    dbTypes: [
      'VARCHAR2(3000)',
      'VARCHAR2(3000)',
      'NUMBER(10,0)',
      'NUMBER(1,0)',
      'BINARY_FLOAT',
      'BINARY_DOUBLE',
      'RAW(2000)',
      'LONG RAW',
      'CHAR(2000)',
      'NCHAR(2000)',
      'BLOB',
      'DATE',
      'INTERVAL YEAR TO MONTH',
      'INTERVAL DAY TO SECOND',
    ],
    schemaToDbTypes: {
      number: 'BINARY_DOUBLE',
      boolean: 'NUMBER(1,0)',
      string: 'VARCHAR2(3000)',
      array: 'VARCHAR2(3000)',
      integer: 'NUMBER(10,0)',
      object: 'VARCHAR2(3000)',
      unknown: 'VARCHAR2(3000)',
    },
  },
  oracle_autonomous: {
    dbTypes: [
      'VARCHAR2(3000)',
      'VARCHAR2(3000)',
      'NUMBER(10,0)',
      'NUMBER(1,0)',
      'BINARY_FLOAT',
      'BINARY_DOUBLE',
      'RAW(2000)',
      'LONG RAW',
      'CHAR(2000)',
      'NCHAR(2000)',
      'BLOB',
      'DATE',
      'TIMESTAMP',
      'INTERVAL YEAR TO MONTH',
      'INTERVAL DAY TO SECOND',
    ],
    schemaToDbTypes: {
      number: 'BINARY_DOUBLE',
      boolean: 'NUMBER(1,0)',
      string: 'VARCHAR2(3000)',
      array: 'VARCHAR2(3000)',
      integer: 'NUMBER(10,0)',
      object: 'VARCHAR2(3000)',
      unknown: 'VARCHAR2(3000)',
    },
  },
  sqlserver: {
    dbTypes: [
      'BIGINT',
      'INT',
      'SMALLINT',
      'TINYINT',
      'BIT',
      'NUMERIC',
      'MONEY',
      'SMALLMONEY',
      'REAL',
      'DATETIME',
      'SMALLDATETIME',
      'CHAR(3000)',
      'VARCHAR(100)',
      'VARCHAR(3000)',
      'VARCHAR(max)',
      'TEXT',
      'NCHAR',
      'NVARCHAR',
      'NTEXT',
      'BINARY',
      'VARBINARY',
      'TABLE',
      'UNIQUEIDENTIFIER',
      'DECIMAL(18, 4)',
      'FLOAT(12)',
    ],
    schemaToDbTypes: {
      number: 'REAL',
      boolean: 'BIT',
      string: 'VARCHAR(3000)',
      array: 'VARCHAR(3000)',
      integer: 'INT',
      object: 'VARCHAR(3000)',
      unknown: 'VARCHAR(3000)',
    },
  },
  cloudsql_sqlserver: {
    dbTypes: [
      'BIGINT',
      'INT',
      'SMALLINT',
      'TINYINT',
      'BIT',
      'NUMERIC',
      'MONEY',
      'SMALLMONEY',
      'REAL',
      'DATETIME',
      'SMALLDATETIME',
      'CHAR(3000)',
      'VARCHAR(100)',
      'VARCHAR(3000)',
      'VARCHAR(max)',
      'TEXT',
      'NCHAR',
      'NVARCHAR',
      'NTEXT',
      'BINARY',
      'VARBINARY',
      'TABLE',
      'UNIQUEIDENTIFIER',
      'DECIMAL(18, 4)',
      'FLOAT(12)',
    ],
    schemaToDbTypes: {
      number: 'REAL',
      boolean: 'BIT',
      string: 'VARCHAR(3000)',
      array: 'VARCHAR(3000)',
      integer: 'INT',
      object: 'VARCHAR(3000)',
      unknown: 'VARCHAR(3000)',
    },
  },
  azure_synapse: {
    dbTypes: [
      'BIGINT',
      'INT',
      'SMALLINT',
      'TINYINT',
      'BIT',
      'NUMERIC',
      'MONEY',
      'SMALLMONEY',
      'REAL',
      'DATETIME',
      'SMALLDATETIME',
      'CHAR(3000)',
      'VARCHAR(100)',
      'VARCHAR(3000)',
      'VARCHAR(max)',
      'TEXT',
      'NCHAR',
      'NVARCHAR',
      'NTEXT',
      'BINARY',
      'VARBINARY',
      'TABLE',
      'UNIQUEIDENTIFIER',
      'DECIMAL(18, 4)',
      'FLOAT(12)',
    ],
    schemaToDbTypes: {
      number: 'REAL',
      boolean: 'BIT',
      string: 'VARCHAR(3000)',
      array: 'VARCHAR(3000)',
      integer: 'INT',
      object: 'VARCHAR(3000)',
      unknown: 'VARCHAR(3000)',
    },
  },
  bigquery: {
    dbTypes: [
      'BOOLEAN',
      'DATE',
      'DATETIME',
      'TIME',
      'TIMESTAMP',
      'FLOAT64',
      'INT64',
      'STRING',
      'NUMERIC',
    ],
    schemaToDbTypes: {
      number: 'FLOAT64',
      boolean: 'BOOLEAN',
      string: 'STRING',
      array: 'STRING',
      integer: 'INT64',
      object: 'STRING',
      unknown: 'STRING',
    },
  },
  as400: {
    dbTypes: [
      'TINYINT',
      'SMALLINT',
      'MEDIUMINT',
      'INT',
      'BIGINT',
      'DECIMAL',
      'FLOAT',
      'DOUBLE',
      'BIT',
      'BOOLEAN',
      'BOOL',
      'CHAR',
      'VARCHAR(4096)',
      'BINARY',
      'VARBINARY(65535)',
      'TINYBLOB',
      'BLOB',
      'MEDIUMBLOB',
      'LONGBLOB',
      'TINYTEXT',
      'TEXT',
      'MEDIUMTEXT',
      'LONGTEXT',
      'ENUM',
      'SET',
      'DATE',
      'DATETIME',
      'TIMESTAMP',
      'YEAR',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'TINYINT(1)',
      string: 'VARCHAR(4096)',
      array: 'VARCHAR(4096)',
      integer: 'INT',
      object: 'VARCHAR(4096)',
      unknown: 'VARCHAR(4096)',
    },
  },
  firebolt: {
    dbTypes: [
      'INT',
      'INTEGER',
      'BIGINT',
      'LONG',
      'FLOAT',
      'DOUBLE',
      'DOUBLE PRECISION',
      'BOOLEAN',
      'VARCHAR',
      'TEXT',
      'STRING',
      'DATE',
      'DATETIME',
      'TIMESTAMP',
      'ARRAY',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'BOOLEAN',
      string: 'VARCHAR',
      array: 'VARCHAR',
      integer: 'INT',
      object: 'VARCHAR',
      unknown: 'TEXT',
    },
  },
  teradata: {
    dbTypes: [
      'BYTEINT',
      'SMALLINT',
      'INTEGER',
      'BIGINT',
      'FLOAT',
      'DOUBLE PRECISION',
      'VARCHAR',
      'VARBYTE(64000)',
      'DATE',
      'TIME',
      'TIMESTAMP',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BYTEINT',
      string: 'LONG VARCHAR CHARACTER SET UNICODE',
      array: 'LONG VARCHAR CHARACTER SET UNICODE',
      integer: 'INTEGER',
      object: 'LONG VARCHAR CHARACTER SET UNICODE',
      unknown: 'VARBYTE(64000)',
    },
  },
  databricks: {
    dbTypes: [
      'BOOLEAN',
      'BYTE',
      'TINYINT',
      'SHORT',
      'SMALLINT',
      'INT',
      'LONG',
      'BIGINT',
      'FLOAT',
      'REAL',
      'DOUBLE',
      'DATE',
      'TIMESTAMP',
      'STRING',
      'BINARY',
      'DECIMAL',
      'NUMERIC',
      'ARRAY',
      'STRUCT',
      'MAP',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'BOOLEAN',
      string: 'STRING',
      array: 'STRING',
      integer: 'INT',
      object: 'STRING',
      unknown: 'STRING',
    },
  },
  netsuite_jdbc: {
    dbTypes: [
      'BIGINT',
      'INT8',
      'BIGSERIAL',
      'SERIAL8',
      'BIT',
      'BIT_VARYING',
      'VARBIT',
      'BOOLEAN',
      'BOOL',
      'BOX',
      'BYTEA',
      'CHAR',
      'VARCHAR',
      'CHARACTER VARYING',
      'CIDR',
      'CIRCLE',
      'DATE',
      'DOUBLE PRECISION',
      'INET',
      'INTEGER',
      'INT',
      'INT4',
      'INTERVAL',
      'JSON',
      'JSONB',
      'LINE',
      'LSEG',
      'MACADDR',
      'MONEY',
      'NUMERIC',
      'DECIMAL',
      'PATH',
      'PG_LSN',
      'POINT',
      'POLYGON',
      'REAL',
      'FLOAT4',
      'SMALLINT',
      'INT2',
      'SMALLSERIAL',
      'SERIAL2',
      'SERIAL',
      'SERIAL4',
      'TEXT',
      'TIME',
      'TIMETZ',
      'TIMESTAMP',
      'TIMESTAMPTZ',
      'TSQUERY',
      'TSVECTOR',
      'TXID_SNAPSHOT',
      'UUID',
      'XML',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE PRECISION',
      boolean: 'BOOLEAN',
      string: 'TEXT',
      array: 'TEXT',
      integer: 'INT',
      object: 'TEXT',
      unknown: 'TEXT',
    },
  },
  db2: {
    dbTypes: [
      'TINYINT',
      'SMALLINT',
      'MEDIUMINT',
      'INT',
      'BIGINT',
      'DECIMAL',
      'FLOAT',
      'DOUBLE',
      'BIT',
      'BOOLEAN',
      'BOOL',
      'CHAR',
      'VARCHAR(4096)',
      'BINARY',
      'VARBINARY(65535)',
      'TINYBLOB',
      'BLOB',
      'MEDIUMBLOB',
      'LONGBLOB',
      'TINYTEXT',
      'TEXT',
      'MEDIUMTEXT',
      'LONGTEXT',
      'ENUM',
      'SET',
      'DATE',
      'DATETIME',
      'TIMESTAMP',
      'YEAR',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'TINYINT(1)',
      string: 'VARCHAR(4096)',
      array: 'VARCHAR(4096)',
      integer: 'INT',
      object: 'VARCHAR(4096)',
      unknown: 'VARCHAR(4096)',
    },
  },
  gcp_spanner: {
    dbTypes: [
      'ARRAY',
      'BOOL',
      'BYTES',
      'DATE',
      'JSON',
      'INT64',
      'NUMERIC',
      'FLOAT64',
      'STRING',
      'TIMESTAMP',
    ],
    schemaToDbTypes: {
      number: 'FLOAT64',
      boolean: 'BOOL',
      string: 'STRING(MAX)',
      char: 'STRING(1)',
      array: 'STRING(MAX)',
      integer: 'INT64',
      float: 'FLOAT64',
      json: 'JSON',
      date: 'DATE',
      timestamp: 'TIMESTAMP',
      object: 'STRING(MAX)',
      unknown: 'STRING(MAX)',
    },
  },
  sybase: {
    dbTypes: [
      'CHAR',
      'NCHAR',
      'VARCHAR',
      'NVARCHAR',
      'LONG NVARCHAR',
      'LONG VARCHAR',
      'TEXT',
      'UNIQUEIDENTIFIERSTR',
      'XML',
      'BIGINT',
      'BOOLEAN',
      'BIT',
      'DECIMAL',
      'DOUBLE',
      'FLOAT',
      'INTEGER',
      'NUMERIC',
      'REAL',
      'SMALLINT',
      'TINYINT',
      'MONEY',
      'SMALLMONEY',
      'LONG VARBIT',
      'VARBIT',
      'DATE',
      'DATETIME',
      'DATETIMEOFFSET',
      'SMALLDATETIME',
      'TIME',
      'TIMESTAMP',
      'TIMESTAMP WITH TIME ZONE',
      'BINARY',
      'VARBINARY',
      'LONG BINARY',
      'UNIQUEIDENTIFIER',
      'IMAGE',
    ],
    schemaToDbTypes: {
      number: 'DOUBLE',
      boolean: 'BOOLEAN',
      string: 'LONG VARCHAR',
      integer: 'INTEGER',
      object: 'LONG VARCHAR',
      unknown: 'LONG VARCHAR',
    },
  },
};
